module.exports = __webpack_public_path__ + "static/media/ios-code.f922b4df.svg";